
import React from 'react';

const ScanLines: React.FC = () => {
  return (
    <div className="pointer-events-none fixed inset-0 z-10 overflow-hidden">
      <div 
        className="absolute inset-0 z-10 bg-gradient-to-b from-transparent via-transparent to-black opacity-20"
      ></div>
      <div 
        className="absolute inset-0 z-10"
        style={{ 
          backgroundImage: 'repeating-linear-gradient(0deg, rgba(0, 255, 102, 0.03), rgba(0, 255, 102, 0.03) 1px, transparent 1px, transparent 2px)',
          backgroundSize: '100% 2px'
        }}
      ></div>
    </div>
  );
};

export default ScanLines;
